/*
 * OffersConstants
 */

export const GET_OFFERS = 'ideal/Offers/GET_OFFERS';
export const OFFERS_RECEIVED = 'ideal/Offers/OFFERS_RECEIVED';
export const SET_LOADING = 'ideal/Offers/SET_LOADING';
